const getPosting = state => state.lead.postingFiltered.posting;
const getId = state => state.lead.postingFiltered.id;
const getLoading = state => state.lead.postingFiltered.loading;
const getCompleteLocation = state => state.lead.postingFiltered.posting.completeLocation;
const getPrice = state => state.lead.postingFiltered.posting.price;
const getCurrency = state => state.lead.postingFiltered.posting.currency;
const getPicture = state => breakpoint =>
  state.lead.postingFiltered.posting.pictures
    ? state.lead.postingFiltered.posting.pictures[state.lead.postingFiltered.imageSizes[breakpoint]]
    : undefined;

export { getPosting, getId, getLoading, getCompleteLocation, getPrice, getCurrency, getPicture };
